import React from 'react';
import { Route } from 'react-router-dom';
import Journeys from './journeys';

export default <Route path="/homepage/jornada" component={Journeys} />;
